module.exports = __webpack_public_path__ + "img/800_5a15abaa0b515.bf34acf5.jpg";